// SEC-006a (audit item M8) and UX-005: the one password policy, used by registration, admin-created users, password
// reset, password change and the two admin reset routes on the server, and by every screen that sets a password
// (live checklist). This file is identical on the server (services/passwordPolicy.js) and in the browser
// (frontend/src/utils/passwordPolicy.js); a test fails if the two ever differ. Do not copy these rules anywhere else.
const PASSWORD_POLICY_MESSAGE = 'Password must be at least 8 characters and include an uppercase letter, a number and a special character.';
const SPECIAL = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

// Each rule: an id, the words shown to the user, and the check. The policy is exactly these four rules.
const PASSWORD_RULES = [
  { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'uppercase', label: 'One uppercase letter (A to Z)', test: (p) => /[A-Z]/.test(p) },
  { id: 'number', label: 'One number (0 to 9)', test: (p) => /\d/.test(p) },
  { id: 'special', label: 'One special character, for example ! @ # $ %', test: (p) => SPECIAL.test(p) },
];

// Returns null when the password is acceptable, otherwise the message to show the user.
function validatePassword(password) {
  if (typeof password !== 'string') return PASSWORD_POLICY_MESSAGE;
  return PASSWORD_RULES.every((r) => r.test(password)) ? null : PASSWORD_POLICY_MESSAGE;
}

// For the live checklist: each rule with whether the password meets it so far.
function checkPasswordRules(password) {
  const p = typeof password === 'string' ? password : '';
  return PASSWORD_RULES.map((r) => ({ id: r.id, label: r.label, met: r.test(p) }));
}

module.exports = { validatePassword, checkPasswordRules, PASSWORD_RULES, PASSWORD_POLICY_MESSAGE };
